<template>
  <div id="app">
    <div id="nav" v-if="!isHeaderFooter">
      <top-header></top-header>
      <whats-app></whats-app>
      <!-- <router-link to="/">Home</router-link> | -->
      <!-- <router-link to="/about">About</router-link> -->
    </div>
    <router-view/>
    <bottom-footer v-if="!isHeaderFooter" />
    <global-loader />
  </div>
</template>

<script>
import topHeader from '@/components/topHeader.vue'
import bottomFooter from '@/components/bottomFooter.vue'
import whatsApp from '@/components/whatsApp.vue'
import GlobalLoader from '@/components/shared/GlobalLoader.vue'

export default {
  metaInfo () {
    return {
      titleTemplate: '',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'viewport',
          name: 'viewport',
          content: 'width=device-width, initial-scale=1'
        }
        // Remove the default description here since we'll override it in components
      ]
    }
  },
  components: {
    'top-header': topHeader,
    'bottom-footer': bottomFooter,
    'whats-app': whatsApp,
    GlobalLoader
  },
  computed: {
    isHeaderFooter () {
      return (
        this.$route.path.includes('login') ||
        this.$route.path.includes('document-signed') ||
        this.$route.path.includes('admin-panel') ||
        this.$route.path.includes('staff-panel') ||
        this.$route.path.includes('user-panel') ||
        this.$route.path.includes('reset-password') ||
        this.$route.path.includes('company-registration-form')
      )
    }
  }
}
</script>

<style lang="scss">
#app {
}
</style>
